import React from "react";
import "./Portfolio.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Portfolio = () => {
  const data1 = [
    "1BHK to 5BHK apartments in Viman Nagar (Eden Garden, Nico Garden, Rohan Mithila)",
    "Luxury bungalows in Nashik, Sangamner, and Pune",
    "Row houses and duplexes in Dhayari, Nanded City (Sur & Kalashree Apartments)",
    "Modern homes in Baner, Vishrantwadi, Kharadi, Alandi",
  ];

  const data2 = [
    "Office spaces designed for functionality and elegance",
    "Retail interiors with customer-focused layouts",
    "Cafes and boutique spaces with customized furniture and ambience design. Each project reflects our commitment to detail, quality materials, and client satisfaction. ",
  ];

  return (
    <section className="Portfolio">
      <div className="container">
        <Common_Title subText=" Portfolio / Our Work " />

        <div className="content_div">
          <div className="row">
            <div className="col-md-6 col-6">
              <div className="points_div">
                <Common_Title darkText=" Portfolio / Our Work " />

                <div className="features_div">
                  <div className="row">
                    {data1?.map((item) => {
                      return (
                        <div className="col-sm-12">
                          <div className="details_card">
                            <img
                              src="/assets/images/home/what_we_do/point_img.png"
                              className="point_img"
                            />

                            <div className="content_div">
                              <p className="descn">{item}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-6">
              <div className="points_div">
                <Common_Title darkText=" Portfolio / Our Work " />

                <div className="features_div">
                  <div className="row">
                    {data2?.map((item) => {
                      return (
                        <div className="col-sm-12">
                          <div className="details_card">
                            <img
                              src="/assets/images/home/what_we_do/point_img.png"
                              className="point_img"
                            />

                            <div className="content_div">
                              <p className="descn">{item}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
